// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"705":"feed68eb","994":"fe9a5690"}[chunkId] + ".chunk.js";
};